'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _expanders = require('../const/expanders');

var _units = require('../const/units');

var _renderBaseline = require('../renderers/renderBaseline');

var _renderBaseline2 = _interopRequireDefault(_renderBaseline);

var _renderDirectionProps = require('../renderers/renderDirectionProps');

var _renderDirectionProps2 = _interopRequireDefault(_renderDirectionProps);

var _renderDualFromOneProps = require('../renderers/renderDualFromOneProps');

var _renderDualFromOneProps2 = _interopRequireDefault(_renderDualFromOneProps);

var _renderDualProps = require('../renderers/renderDualProps');

var _renderDualProps2 = _interopRequireDefault(_renderDualProps);

var _baselineTransformer = require('../transformers/composite/baselineTransformer');

var _baselineTransformer2 = _interopRequireDefault(_baselineTransformer);

var _dataLookupTransformers = require('../transformers/factory/dataLookupTransformers');

var _gradientTransformer = require('../transformers/gradientTransformer');

var _gradientTransformer2 = _interopRequireDefault(_gradientTransformer);

var _lengthTransformers = require('../transformers/lengthTransformers');

var _lengthTransformers2 = _interopRequireDefault(_lengthTransformers);

var _percentageStringToRatioTransformer = require('../transformers/percentageStringToRatioTransformer');

var _percentageStringToRatioTransformer2 = _interopRequireDefault(_percentageStringToRatioTransformer);

var _transformTransformer = require('../transformers/transformTransformer');

var _transformTransformer2 = _interopRequireDefault(_transformTransformer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// -----------------------------------------------------------------------------
// Define API
// -----------------------------------------------------------------------------

var defaultConfig = {
  breakpoints: [],
  data: {
    aliases: {
      c: 'color',
      g: 'gradient',
      s: 'scale',
      d: 'boxShadow',
      b: 'border',
      i: 'image',
      f: 'font'
    },
    lengthUnit: _units.LENGTH_UNITS.REM, // | LENGTH_UNITS.PX | LENGTH_UNITS.EM
    baseFontSize: 16, // Font size of your page's root element
    rhythm: 20, // Unit of rhythm for use in layout
    baseline: {
      lineHeight: 20, // Baseline height
      minLeading: 2, // Minimum remaining leading before line or half-line added
      allowHalfLines: true // Allow half-lines to be used in baseline calc
    },
    color: {},
    scale: {},
    gradient: {},
    boxShadow: {},
    image: {},
    border: {}
  },
  api: {
    // -------------------------------------------------------------------------
    // Box Model
    // -------------------------------------------------------------------------

    padding: {
      transformers: _lengthTransformers2.default
    },
    margin: {
      transformers: _lengthTransformers2.default
    },
    border: {
      transformers: [_dataLookupTransformers.borderLookupTransformer, _lengthTransformers2.default, _dataLookupTransformers.colorLookupTransformer]
    },
    borderWidth: {
      transformers: _lengthTransformers2.default
    },
    borderColor: {
      transformers: _dataLookupTransformers.colorLookupTransformer
    },
    borderStyle: {},
    borderSpacing: {
      transformers: _lengthTransformers2.default
    },
    borderRadius: {
      transformers: _lengthTransformers2.default
    },
    borderImageSource: {
      transformers: [_dataLookupTransformers.imageLookupTransformer, _dataLookupTransformers.gradientLookupTransformer, (0, _gradientTransformer2.default)([_dataLookupTransformers.colorLookupTransformer].concat(_toConsumableArray(_lengthTransformers2.default)))]
    },

    // -------------------------------------------------------------------------
    // Outline
    // -------------------------------------------------------------------------

    outline: {
      transformers: [_dataLookupTransformers.borderLookupTransformer, _lengthTransformers2.default, _dataLookupTransformers.colorLookupTransformer]
    },
    outlineColor: {
      transformers: _dataLookupTransformers.colorLookupTransformer
    },
    outlineOffset: {
      transformers: _lengthTransformers2.default
    },
    outlineStyle: {},
    outlineWidth: {
      transformers: _lengthTransformers2.default
    },

    // -------------------------------------------------------------------------
    // Text
    // -------------------------------------------------------------------------

    fontFamily: {
      transformers: _dataLookupTransformers.fontLookupTransformer
    },
    fontSize: {
      transformers: [_dataLookupTransformers.scaleLookupTransformer, _lengthTransformers2.default]
    },
    fontWeight: {},
    fontVarient: {},
    fontStretch: {},
    fontStyle: {},
    lineHeight: {
      transformers: _lengthTransformers2.default
    },
    textAlign: {},
    letterSpacing: {
      transformers: _lengthTransformers2.default
    },
    wordWrap: {},
    wordSpacing: {},
    textDecoration: {},
    whiteSpace: {},

    // -------------------------------------------------------------------------
    // List
    // -------------------------------------------------------------------------

    listStyle: {
      transformers: _dataLookupTransformers.imageLookupTransformer
    },
    listStyleImage: {
      transformers: _dataLookupTransformers.imageLookupTransformer
    },
    listStylePosition: {},
    listStyleType: {},

    // -------------------------------------------------------------------------
    // Background
    // -------------------------------------------------------------------------

    background: {
      transformers: [_dataLookupTransformers.colorLookupTransformer, _dataLookupTransformers.imageLookupTransformer, _dataLookupTransformers.gradientLookupTransformer, (0, _gradientTransformer2.default)([_dataLookupTransformers.colorLookupTransformer].concat(_toConsumableArray(_lengthTransformers2.default))), _dataLookupTransformers.imageLookupTransformer]
    },

    backgroundAttachment: {},

    backgroundClip: {},

    backgroundColor: {
      transformers: _dataLookupTransformers.colorLookupTransformer
    },

    backgroundImage: {
      transformers: [_dataLookupTransformers.gradientLookupTransformer, _dataLookupTransformers.imageLookupTransformer, (0, _gradientTransformer2.default)([_dataLookupTransformers.colorLookupTransformer].concat(_toConsumableArray(_lengthTransformers2.default))), _dataLookupTransformers.imageLookupTransformer]
    },

    backgroundOrigin: {},

    backgroundPosition: {
      transformers: _lengthTransformers2.default
    },

    backgroundRepeat: {},

    backgroundSize: {
      transformers: _lengthTransformers2.default
    },

    // -------------------------------------------------------------------------
    // Color / Visibility
    // -------------------------------------------------------------------------

    opacity: {
      transformers: _percentageStringToRatioTransformer2.default
    },
    color: {
      transformers: _dataLookupTransformers.colorLookupTransformer
    },
    visibility: {},

    // -------------------------------------------------------------------------
    // Layout
    // -------------------------------------------------------------------------

    display: {},
    float: {},
    clear: {},
    position: {},
    directions: {
      transformers: _lengthTransformers2.default
    },
    width: {
      transformers: _lengthTransformers2.default
    },
    height: {
      transformers: _lengthTransformers2.default
    },

    // -------------------------------------------------------------------------
    // Flexbox
    // -------------------------------------------------------------------------

    flex: {
      transformers: _lengthTransformers2.default
    },
    flexDirection: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    alignSelf: {},
    flexBasis: {
      transformers: _lengthTransformers2.default
    },
    flexShrink: {}, // Doesn't support <length> values
    flexGrow: {}, // Doesn't support <length> values
    flexWrap: {},
    order: {},

    // -------------------------------------------------------------------------
    // Columns
    // -------------------------------------------------------------------------

    columnCount: {},

    columnWidth: {
      transformers: _lengthTransformers2.default
    },

    columnGap: {
      transformers: _lengthTransformers2.default
    },

    columnRuleWidth: {
      transformers: _lengthTransformers2.default
    },

    // -------------------------------------------------------------------------
    // Tables
    // -------------------------------------------------------------------------

    verticalAlign: {},

    // -------------------------------------------------------------------------
    // Misc
    // -------------------------------------------------------------------------

    zIndex: {},
    zoom: {},
    overflow: {},
    boxShadow: {
      transformers: [_dataLookupTransformers.boxShadowLookupTransformer, _dataLookupTransformers.colorLookupTransformer, _lengthTransformers2.default]
    },
    cursor: {},
    hyphens: {},

    // -------------------------------------------------------------------------
    // Transforms
    // -------------------------------------------------------------------------

    transform: { transformers: (0, _transformTransformer2.default)(_lengthTransformers2.default) },
    transformBox: {},
    transformOrigin: {
      transformers: _lengthTransformers2.default
    },

    // -------------------------------------------------------------------------
    // SVG
    // -------------------------------------------------------------------------

    fill: {
      transformers: [_dataLookupTransformers.colorLookupTransformer, _dataLookupTransformers.gradientLookupTransformer, (0, _gradientTransformer2.default)([_dataLookupTransformers.colorLookupTransformer].concat(_toConsumableArray(_lengthTransformers2.default)))]
    },

    stroke: {
      transformers: [_dataLookupTransformers.colorLookupTransformer, _dataLookupTransformers.gradientLookupTransformer, (0, _gradientTransformer2.default)([_dataLookupTransformers.colorLookupTransformer].concat(_toConsumableArray(_lengthTransformers2.default)))]
    },

    stopColor: {
      transformers: [_dataLookupTransformers.colorLookupTransformer]
    },

    // -------------------------------------------------------------------------
    // Helpers
    // -------------------------------------------------------------------------

    paddingH: {
      transformers: _lengthTransformers2.default,
      renderer: (0, _renderDualProps2.default)(['paddingLeft', 'paddingRight'])
    },

    paddingV: {
      transformers: _lengthTransformers2.default,
      renderer: (0, _renderDualProps2.default)(['paddingTop', 'paddingBottom'])
    },

    marginH: {
      transformers: _lengthTransformers2.default,
      renderer: (0, _renderDualProps2.default)(['marginRight', 'marginLeft'])
    },

    marginV: {
      transformers: _lengthTransformers2.default,
      renderer: (0, _renderDualProps2.default)(['marginTop', 'marginBottom'])
    },

    borderH: {
      transformers: [_dataLookupTransformers.borderLookupTransformer, _lengthTransformers2.default, _dataLookupTransformers.colorLookupTransformer],
      renderer: (0, _renderDualFromOneProps2.default)(['borderLeft', 'borderRight'])
    },

    borderV: {
      transformers: [_dataLookupTransformers.borderLookupTransformer, _lengthTransformers2.default, _dataLookupTransformers.colorLookupTransformer],
      renderer: (0, _renderDualFromOneProps2.default)(['borderTop', 'borderBottom'])
    },

    offset: {
      transformers: _lengthTransformers2.default,
      renderer: _renderDirectionProps2.default
    },

    offsetV: {
      transformers: _lengthTransformers2.default,
      renderer: (0, _renderDualProps2.default)(_expanders.DIRECTIONS_LIST_VERTICAL)
    },

    offsetH: {
      transformers: _lengthTransformers2.default,
      renderer: (0, _renderDualProps2.default)(_expanders.DIRECTIONS_LIST_HORIZONTAL)
    },

    borderTopRadius: {
      transformers: _lengthTransformers2.default,
      renderer: (0, _renderDualProps2.default)(['borderTopLeftRadius', 'borderTopRightRadius'])
    },

    borderRightRadius: {
      transformers: _lengthTransformers2.default,
      renderer: (0, _renderDualProps2.default)(['borderTopRightRadius', 'borderBottomRightRadius'])
    },

    borderBottomRadius: {
      transformers: _lengthTransformers2.default,
      renderer: (0, _renderDualProps2.default)(['borderBottomRightRadius', 'borderBottomLeftRadius'])
    },

    borderLeftRadius: {
      transformers: _lengthTransformers2.default,
      renderer: (0, _renderDualProps2.default)(['borderBottomLeftRadius', 'borderTopLeftRadius'])
    },

    baseline: {
      transformers: (0, _baselineTransformer2.default)([_dataLookupTransformers.scaleLookupTransformer, _lengthTransformers2.default]),
      renderer: _renderBaseline2.default
    }
  }
};

exports.default = defaultConfig;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/config/defaultConfig.js
// module id = 652
// module chunks = 168707334958949